import React from "react";
import Navbar from "../components/Navbar";
import "../css/PolicyPages.css";
import "../css/global.css";
import { useContacts } from "../context/ContactsContext";

// Last updated date for this policy
const LAST_UPDATED = "21/11/2025";

const TermsOfService = () => {
  const { contacts } = useContacts();

  return (
    <div className="policy-page">
      <Navbar />
      <div className="policy-container">
        <h1>Termini e Condizioni di Servizio</h1>
        <div className="policy-content">
          <p className="last-updated">Ultimo aggiornamento: {LAST_UPDATED}</p>

          <section>
            <h2>1. Accettazione dei Termini</h2>
            <p>
              Accedendo e utilizzando questo sito web, accetti di essere vincolato da questi Termini e Condizioni di Servizio. 
              Se non accetti questi termini, ti preghiamo di non utilizzare il nostro sito.
            </p>
          </section>

          <section>
            <h2>2. Informazioni sulla Società</h2>
            <p>
              Il presente sito web è gestito da:<br/>
              <strong>{contacts.COMPANY_NAME}</strong><br/>
              Sede legale: {contacts.ADDRESS_LINE}, {contacts.ADDRESS_CITY}<br/>
              P. IVA: {contacts.VAT_NUMBER}<br/>
              Email: {contacts.CONTACT_EMAIL}
            </p>
          </section>

          <section>
            <h2>3. Utilizzo del Sito</h2>
            <p>
              Questo sito ha lo scopo di fornire informazioni sui nostri prodotti e servizi nel settore dei serramenti 
              in alluminio, ferro, PVC e legno. L'utilizzo del sito è consentito esclusivamente per scopi leciti e 
              in conformità con questi termini.
            </p>
            <p>Ti impegni a non:</p>
            <ul>
              <li>Utilizzare il sito in modo da violare leggi o regolamenti applicabili;</li>
              <li>Trasmettere materiale offensivo, diffamatorio o illegale;</li>
              <li>Interferire con il funzionamento del sito o dei suoi server;</li>
              <li>Tentare di accedere senza autorizzazione a parti protette del sito;</li>
              <li>Copiare, riprodurre o distribuire contenuti del sito senza autorizzazione.</li>
            </ul>
          </section>

          <section>
            <h2>4. Proprietà Intellettuale</h2>
            <p>
              Tutti i contenuti presenti su questo sito, inclusi testi, immagini, loghi, grafici e software, 
              sono di proprietà di {contacts.COMPANY_NAME} o dei rispettivi proprietari e sono protetti dalle leggi 
              sul diritto d'autore e sulla proprietà intellettuale.
            </p>
            <p>
              È vietata la riproduzione, distribuzione, modifica o utilizzo dei contenuti senza il preventivo 
              consenso scritto del proprietario.
            </p>
          </section>

          <section>
            <h2>5. Limitazione di Responsabilità</h2>
            <p>
              Le informazioni fornite su questo sito sono a scopo informativo generale. Sebbene ci sforziamo 
              di mantenere le informazioni aggiornate e accurate, non garantiamo la completezza, l'accuratezza 
              o l'affidabilità delle informazioni.
            </p>
            <p>
              {contacts.COMPANY_NAME} non sarà responsabile per eventuali danni diretti, indiretti, incidentali o 
              consequenziali derivanti dall'utilizzo o dall'impossibilità di utilizzare questo sito.
            </p>
          </section>

          <section>
            <h2>6. Link a Siti di Terze Parti</h2>
            <p>
              Il nostro sito potrebbe contenere link a siti web di terze parti. Questi link sono forniti 
              solo per comodità e non implica la nostra approvazione dei contenuti di tali siti. 
              Non siamo responsabili per il contenuto o le pratiche di privacy di siti di terze parti.
            </p>
          </section>

          <section>
            <h2>7. Modifiche ai Termini</h2>
            <p>
              Ci riserviamo il diritto di modificare questi Termini e Condizioni in qualsiasi momento. 
              Le modifiche saranno effettive immediatamente dopo la pubblicazione su questa pagina. 
              L'uso continuato del sito dopo le modifiche costituisce l'accettazione dei nuovi termini.
            </p>
          </section>

          <section>
            <h2>8. Privacy</h2>
            <p>
              Il trattamento dei tuoi dati personali è descritto nella nostra <a href="/privacy-policy" className="link">Privacy Policy</a>. 
              Utilizzando il nostro sito, accetti anche la nostra Privacy Policy.
            </p>
          </section>

          <section>
            <h2>9. Legge Applicabile e Foro Competente</h2>
            <p>
              Questi Termini e Condizioni sono regolati dalla legge italiana. Per qualsiasi controversia 
              derivante da questi termini, sarà competente il foro di Firenze.
            </p>
          </section>

          <section>
            <h2>10. Contatti</h2>
            <p>
              Per qualsiasi domanda riguardante questi Termini e Condizioni, puoi contattarci a:<br/>
              Email: <a href={`mailto:${contacts.CONTACT_EMAIL}`} className="link">{contacts.CONTACT_EMAIL}</a>
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;
